import withConfigTransport from '../../../../services/config-transport/withConfigTransport'
import VaRatingItem from './VaRatingItem.vue'

export default withConfigTransport(VaRatingItem)
